import * as React from "react";
import { Property } from "../../core/api/models/property";

interface IGeneralInfoTabProps {
  property: Property;
  reload?: () => void;
}

const AttributeInfoTab: React.FunctionComponent<IGeneralInfoTabProps> = (
  props
) => {
  return (
    <div className="px-4 pt-3 pb-2" style={{ maxWidth: "650px" }}>
      <div className="row mb-3 font-md font-weight-bold">Attribute Info</div>
      {props.property.attributes?.map((up) => {
        // const attrOptionValue =  up?.attrOptionValue?.replace(/[#~]+/g, "")?.replace(/\s\s+/g, " ");
        const attrOptionValue = typeof up?.attrOptionValue === 'string'
          ? up?.attrOptionValue?.replace(/<br\s*\/?>/gi, '\n').replace(/[~]/g, '')
          : up.attrOptionValue

        return (
          <div className="row border-bottom py-2" key={up.attrName}>
            <div className="col-md-3 col-5 font-sm text-gray-500 pl-0 py-1">
              {up.attrName}
            </div>
            <div className="col-md-9 col-7 font-sm font-weight-semibold py-1">
              {attrOptionValue}
            </div>
          </div>
        );
      })}
      <div className="row border-bottom py-2">
        <div className="col-md-3 col-5 font-sm text-gray-500 pl-0 py-1">
          Number Of Seats
        </div>
        <div className="col-md-9 col-7 font-sm font-weight-semibold py-1">
          {props.property.numberOfSeats}
        </div>
      </div>
    </div>
  );
};

export default AttributeInfoTab;
